import type { CreateTalent, Talent, TalentJobHistoryEntry } from "@/api/talent/models";
import { DeleteTalentRequestOriginEnum } from "@/enums/talent";
import type { PaginationResponse } from "@/interfaces/api";
import { api } from "@/services/api";
import { crud } from "../crud";

export const talentCrud = crud<Talent, CreateTalent>("talent", "Talent");

export async function getTalentJobHistory(
  talentId: string,
  page: number,
): Promise<PaginationResponse<TalentJobHistoryEntry>> {
  const response = await api.get<PaginationResponse<TalentJobHistoryEntry>>(`/talent/${talentId}/job-history`, {
    params: { page },
  });

  return response.data;
}

export async function postSpecialTalentAction(id: string, payload: any): Promise<Talent> {
  const response = await api.patch<Talent>(`/talent/${id}/archive`, payload);
  return response.data;
}

export async function patchUnarchiveTalents(payload: { talentIds: string[] }): Promise<void> {
  const response = await api.patch<void>(`/talent/unarchive-multiple`, payload);
  return response.data;
}
export async function deleteMultipleTalents(payload: {
  talentIds: string[];
  origin: DeleteTalentRequestOriginEnum;
}): Promise<void> {
  const response = await api.delete<void>(`/talent/delete-multiple`, { data: payload });
  return response.data;
}
